import { render } from "./Login.vue?vue&type=template&id=24b5c7ea&scoped=true"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"

import "./custom-login.scss?vue&type=style&index=0&id=24b5c7ea&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24b5c7ea"]])

export default __exports__